// extracted by mini-css-extract-plugin
module.exports = {"CMSContent":"style_CMSContent__elVzp"};